export enum RecipeModalSortOptions {
  RecipeAZ = 'RECAZ',
  RecipeZA = 'RECZA',
  GroupAZ = 'GROUPAZ',
  GroupZA = 'GROUPZA',
  Serving09 = 'SERVE09',
  Serving90 = 'SERVE90',
  CostServ09 = 'COST09',
  CostServ90 = 'COST90',
}
